import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
export default (function (context, inject) {
  var plugin = {
    /**
     * Check if the current user has all the required grant/actions
     * @param {string} model - Model name for grant (e.g. 'customer')
     * @param {array} actions - A list of required grants (e.g. ['edit', 'list', 'view'])
     * @returns boolean
     */
    get: function get(_ref) {
      var model = _ref.model,
        actions = _ref.actions;
      var active = context.$auth.active;
      var grants = this.list;

      // Check if there is an active user and grants are available
      if (!active || !grants) {
        return false;
      }

      // Check if the user has the required model
      if (!grants[model]) {
        return false;
      }

      // Loop through actions requested
      var _iterator = _createForOfIteratorHelper(actions),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var action = _step.value;
          // Check if the user has the required action
          if (!grants[model].includes(action)) {
            return false;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return true;
    },
    /**
     * Check if the current user has all the required grant/actions in object
     * @param {object} grants - A list of grants (model and actions))
     * @returns boolean
     */
    all: function all(grants) {
      var _this = this;
      return Object.entries(grants).every(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          model = _ref3[0],
          actions = _ref3[1];
        return _this.get({
          model: model,
          actions: actions
        });
      });
    },
    /**
     * Check if the current user has any of the required grant/actions in object
     * @param {object} grants - A list of grants (model and actions))
     * @returns boolean
     */
    any: function any(grants) {
      var _this2 = this;
      return Object.entries(grants).some(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          model = _ref5[0],
          actions = _ref5[1];
        var active = context.$auth.active;
        var grants = _this2.list;

        // Check if there is an active user and grants are available
        if (!active || !grants) {
          return false;
        }

        // Check if the user has the required model
        if (!grants[model]) {
          return false;
        }

        // Loop through actions requested
        var _iterator2 = _createForOfIteratorHelper(actions),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var action = _step2.value;
            // Check if the user has the required action
            if (grants[model].includes(action)) {
              return true;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        return false;
      });
    },
    /**
     * Return the required grants for a given path
     * @param {string} path - A path to check
     * @returns boolean
     */
    route: function route(path) {
      if (!path) {
        return false;
      }
      var resolved = context.app.router.resolve(path);
      var grants = resolved && resolved.route ? resolved.route.meta.grants : null;
      return grants;
    },
    /**
     * Check if current user has required grants for given path
     * @param {string} path - A path to check
     * @returns boolean
     */
    access: function access(path) {
      if (!path) {
        return false;
      }
      var resolved = context.app.router.resolve(path);
      var grants = resolved && resolved.route ? resolved.route.meta.grants : null;
      if (!grants) {
        return true;
      }
      return this.all(grants);
    },
    /**
     * Get the current active user role info
     */
    get role() {
      var _context$$auth$active, _context$$auth$active2, _context$$auth$active3;
      return (_context$$auth$active = context.$auth.active) === null || _context$$auth$active === void 0 ? void 0 : (_context$$auth$active2 = _context$$auth$active.info) === null || _context$$auth$active2 === void 0 ? void 0 : (_context$$auth$active3 = _context$$auth$active2.employee) === null || _context$$auth$active3 === void 0 ? void 0 : _context$$auth$active3.role;
    },
    /**
     * Get a list of the current users grants
     */
    get list() {
      return context.store.getters['auth/grants'];
    }
  };
  inject('grants', plugin);
});